module Visonum.BulkPingApp.AppHTML
  ( AppComponentHTML
  , AppCtx
  , AppHTML
  , styleLeaf
  , styleNode
  , styleNodeKeyed
  ) where

import Prelude

import Effect.Aff (Aff)
import Halogen (ComponentSlot)
import Halogen.HTML (AttrName(..), HTML)
import Halogen.HTML.Properties as HP
import Halogen.Styled (Leaf, Node, NodeKeyed, StyledHTML, UpdateOpts(..))
import Halogen.Styled as Styled
import Visonum.BulkPingApp.StaticConfig (StaticConfig)

type AppCtx =
  { debug :: Boolean
  , staticConfig :: StaticConfig
  }

type AppHTML w a = StyledHTML AppCtx w a

type AppComponentHTML action slots = AppHTML (ComponentSlot slots Aff action) action

styleNode
  :: forall r w a
   . Node (HTML w) r a
  -> String
  -> Array (UpdateOpts AppCtx r a)
  -> Node (StyledHTML AppCtx w) r a
styleNode node name opts = Styled.styleNode node ([ debug name ] <> opts)

styleNodeKeyed
  :: forall r w a
   . NodeKeyed (HTML w) r a
  -> String
  -> Array (UpdateOpts AppCtx r a)
  -> NodeKeyed (StyledHTML AppCtx w) r a
styleNodeKeyed nodeKeyed name opts = Styled.styleNodeKeyed nodeKeyed ([ debug name ] <> opts)

styleLeaf
  :: forall r w a
   . Leaf (HTML w) r a
  -> String
  -> Array (UpdateOpts AppCtx r a)
  -> Leaf (StyledHTML AppCtx w) r a
styleLeaf leaf name opts = Styled.styleLeaf leaf ([ debug name ] <> opts)

debug :: forall r a. String -> UpdateOpts AppCtx r a
debug name = UpdateOpts \r ->
  if r.context.debug then
    r
      { name = name
      , props = r.props <> [ HP.attr (AttrName "data-label") name ]
      }
  else r